import { View } from 'react-native'
import styled from 'styled-components'
import { media } from '@flix/common/style/media'

export const LoadingSection = styled(View)`
  text-align: center;
  margin: 70px 0 280px;

  ${media.sm`
    margin-top: 130px;
  `};
`

export default LoadingSection
